<template>
  <div class="login-wrapper">
    <div class="login-container">
      <div class="login-header">
        <h1>开票系统</h1>
        <p>请使用手机号密码登录</p>
      </div>
      
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="phone">手机号</label>
          <input type="tel" id="phone" v-model="phone" placeholder="请输入手机号" maxlength="11" @input="validatePhone">
          <div class="error-message" v-show="phoneError">{{ phoneError }}</div>
        </div>
        
        <div class="form-group">
          <label for="password">密码</label>
          <input type="password" id="password" v-model="password" placeholder="请输入密码" @input="validatePassword">
          <div class="error-message" v-show="passwordError">{{ passwordError }}</div>
        </div>
        
        <button type="submit" class="login-btn" :disabled="isLoading">{{ isLoading ? '登录中...' : '登录' }}</button>
      </form>
      
      <div class="footer">
        © 2026 开票系统 深圳驭风网络科技有限公司版权所有
      </div>
    </div>
    
    <!-- 自定义错误弹窗 -->
    <div class="custom-modal" v-show="showErrorModal">
      <div class="custom-modal-content">
        <div class="custom-modal-body">
          <p class="error-message-text">{{ errorMessage }}</p>
        </div>
        <div class="custom-modal-footer">
          <button class="btn btn-primary" @click="closeErrorModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/api'
import CryptoJS from 'crypto-js'

export default {
  name: 'LoginPage',
  data() {
    return {
      phone: '',
      password: '',
      phoneError: '',
      passwordError: '',
      isLoading: false,
      gameId: '90032', // 请替换为实际的 gameId
      clientKey: '1b4d5a6330bf4fd1ead1aeec25085d62', // 请替换为实际的 clientKey
      encryptionKey: 'higameAES123456', // 请替换为实际的加密密钥
      encryptionIv: '00000000000000000000000000000000', // 请替换为实际的加密向量
      showErrorModal: false,
      errorMessage: ''
    }
  },
  methods: {
    // 十六进制转字符串（与PHP hexToStr 完全等效）
    hexToStr(hex) {
      let string = ''
      const len = hex.length - 1 // 与PHP保持一致，减1处理
      for (let i = 0; i < len; i += 2) {
        // 截取两位十六进制，转十进制，再转字符（对齐PHP逻辑）
        const byte = parseInt(hex.substr(i, 2), 16)
        string += String.fromCharCode(byte)
      }
      return string
    },
    
    // 加密函数（与PHP encode 完全等效）
    encrypt(str) {
      try {
        // 1. 处理密钥 - 默认使用256位（SHA256）
        let key = this.encryptionKey
        // 256位加密：使用SHA256哈希，获取原始二进制数据（与PHP hash('sha256', $key, true) 等效）
        key = CryptoJS.SHA256(key)
        // 直接使用SHA256的WordArray结果

        // 2. 处理向量
        const ivStr = this.hexToStr(this.encryptionIv)
        const iv = CryptoJS.enc.Utf8.parse(ivStr)

        // 3. PKCS7 填充（与PHP一致）
        const blockSize = 16
        const pad = blockSize - (str.length % blockSize)
        // 手动填充，与PHP逻辑一致
        for (let i = 0; i < pad; i++) {
          str += String.fromCharCode(pad)
        }

     

        // 4. AES-128-CBC 加密
        const encrypted = CryptoJS.AES.encrypt(str, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.NoPadding // 关闭自动填充，使用手动填充
        })

        // 5. 转Base64输出
        const result = encrypted.ciphertext.toString(CryptoJS.enc.Base64)
        
        return result
      } catch (error) {
        console.error('加密出错:', error)
        return ''
      }
    },

    validatePhone() {
      if (/^1[3-9]\d{9}$/.test(this.phone)) {
        this.phoneError = ''
      }
    },
    validatePassword() {
      if (this.password.length >= 6) {
        this.passwordError = ''
      }
    },
    // 显示错误弹窗
    showError(message) {
      this.errorMessage = message
      this.showErrorModal = true
    },
    
    // 关闭错误弹窗
    closeErrorModal() {
      this.showErrorModal = false
      this.errorMessage = ''
    },
    
    async handleLogin() {
      let isValid = true
      
      // 验证手机号
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.phoneError = '请输入正确的手机号'
        isValid = false
      } else {
        this.phoneError = ''
      }
      
      // 验证密码
      if (this.password.length < 6) {
        this.passwordError = '请输入密码'
        isValid = false
      } else {
        this.passwordError = ''
      }
      
      if (isValid) {
        this.isLoading = true
        
        try {
          // 加密密码
          const encryptedPassword = this.encrypt(this.password)
          
          // 调用登录接口
          const response = await login({
            gameId: this.gameId,
            clientKey: this.clientKey,
            password: encryptedPassword,
            phone: this.phone
          })
         
          // 处理登录成功
          if (response && response.Status === 1) {
            //console.log('登录成功:', response)
            // 存储token等信息
            if (response.token) {
              localStorage.setItem('token', response.token)
            }
            // 存储Sdkuid作为userId
            if (response.Sdkuid) {
              localStorage.setItem('userId', response.Sdkuid)
            }
            // 存储gameId
            localStorage.setItem('gameId', this.gameId)
            // 跳转到订单页面
            this.$router.push('/order-billing')
          } else {
            console.error('登录失败:', response)
            this.showError('登录失败: ' + (response.msg || '未知错误'))
          }
        } catch (error) {
          console.error('登录失败:', error)
          // 显示错误信息
          this.showError('登录失败，请检查网络或账号密码')
        } finally {
          this.isLoading = false
        }
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-wrapper {
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
  transition: transform 0.3s ease;
}

.login-container:hover {
  transform: translateY(-5px);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  color: #333;
  font-size: 24px;
  margin-bottom: 10px;
}

.login-header p {
  color: #666;
  font-size: 14px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #333;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-top: 10px;
}

.login-btn:hover {
  background: #5a6fe0;
}

.login-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.error-message {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 5px;
}

.footer {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #999;
}

@media (max-width: 768px) {
  .login-container {
    padding: 30px 20px;
    margin: 0 20px;
  }
  
  .login-header h1 {
    font-size: 20px;
  }
  
  .login-header p {
    font-size: 13px;
  }
  
  .form-group {
    margin-bottom: 16px;
  }
  
  .form-group label {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  .form-group input {
    padding: 10px 12px;
    font-size: 14px;
  }
  
  .login-btn {
    padding: 12px;
    font-size: 14px;
  }
  
  .footer {
    font-size: 11px;
    margin-top: 16px;
  }
  
  .custom-modal-content {
    margin: 0 20px;
    min-width: auto;
    max-width: 90%;
  }
}

/* 自定义错误弹窗样式 */
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.custom-modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: modalFadeIn 0.3s ease;
  min-width: 320px;
  max-width: 400px;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.custom-modal-body {
  padding: 24px 24px 10px 24px;
  text-align: center;
}

.error-message-text {
  font-size: 16px;
  color: #ff4d4f;
  margin: 0;
  line-height: 1.4;
}

.custom-modal-footer {
  padding: 0 24px 24px;
  display: flex;
  justify-content: center;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #5a6fe0;
}
</style>